// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__OrZH5","expandIcon":"AccordionButton_expandIcon__o4ACE","expanded":"AccordionButton_expanded__2zv9j"};